var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.000976562,
    width: 42,
    height: 42,
    rx: 8,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.0879 18.9789C29.072 19.0216 27.1906 18.4231 25.5778 17.3114V24.9649C25.5778 27.8723 23.6964 30.4377 20.8293 31.4638C18.0071 32.49 14.7817 31.7204 12.8106 29.5397C10.7947 27.3165 10.4364 24.1953 11.8699 21.6298C13.3034 19.1072 16.26 17.6962 19.3062 18.081V21.9291C17.9175 21.5016 16.3944 21.9719 15.5433 23.0836C14.7369 24.2379 14.7369 25.7345 15.5881 26.8462C16.4392 27.9578 17.9623 28.4282 19.3062 28.0005C20.6949 27.573 21.6356 26.333 21.6356 24.9649V10H25.5778C25.5778 10.3421 25.5778 10.6413 25.6675 10.9834C25.9362 12.3944 26.7874 13.6343 28.0865 14.4039C28.9377 14.9598 30.0127 15.2591 31.0879 15.2591V18.9789Z",
    fill: "#262627"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.491771cf5a70ffeb3cf1c85701fae32b.svg";
export { ForwardRef as ReactComponent };